


























import Vue from 'vue';
import Tracker from './components/Tracker.vue';

export default Vue.extend({
  name: 'App',
  components: {
    Tracker
  }
});
